module.exports = __webpack_public_path__ + "static/v1-6b8792f26717405d2a3f1cbae6f4e892.png";